import { useAppDispatch, useAppSelector } from "app/hooks";

import { useStrings } from "features/i18n/useStrings";

import { GuxFormFieldNumber } from "genesys-spark-components-react";
import strings from "./PassPercent.strings";
import { qualityFormActions } from "../qualityFormSlice";
import { selectForm } from "../qualityFormSlices/qualityFormCommons";
import embeddingService from "services/embeddingService";
import {
    invalidIntegerInputCharacters,
    selectIsPassPercentAnInteger,
    selectIsPassPercentInLimits,
} from "../qualityFormValidations";
import { useEffect, CompositionEvent, useRef } from "react";
import { disableInputScroll } from "./common/DisableInputScroll";
import { DefaultLimits } from "constants/DefaultLimits";

export default function PassPercent({ disabled }: { disabled?: boolean }) {
    const t = useStrings(strings);

    const dispatch = useAppDispatch();
    const passPercent = useAppSelector(
        (state) =>
            selectForm(state)?.passPercent ?? DefaultLimits.minPassPercent
    );
    const passPercentErrorMessage = useAppSelector((state) =>
        isNaN(passPercent)
            ? t.errors.passPercentEmpty
            : !selectIsPassPercentInLimits(state)
            ? t.errors.passPercentValue
            : !selectIsPassPercentAnInteger(state)
            ? t.errors.passPercentNotAnInteger
            : undefined
    );

    useEffect(() => {
        embeddingService.sendPassMarkPercentage(passPercent);
    }, [passPercent]);

    const numberInputRef = useRef<HTMLInputElement>(null);
    useEffect(() => disableInputScroll(numberInputRef));

    return (
        <GuxFormFieldNumber className="PassPercent" labelPosition="above">
            <input
                slot="input"
                type="number"
                ref={numberInputRef}
                step="1"
                min={DefaultLimits.minPassPercent}
                max={DefaultLimits.maxPassPercent}
                value={passPercent}
                onBeforeInput={(event: CompositionEvent<HTMLInputElement>) => {
                    if (invalidIntegerInputCharacters.includes(event.data)) {
                        event.preventDefault();
                    }
                }}
                onChange={({ currentTarget }) => {
                    dispatch(
                        qualityFormActions.changePassPercent(
                            currentTarget.valueAsNumber
                        )
                    );
                }}
                required
                disabled={disabled}
                aria-disabled={disabled}
            />
            <label slot="label">{t.labels.passMark}</label>
            {passPercentErrorMessage && (
                <span slot="error" role="alert">
                    {passPercentErrorMessage}
                </span>
            )}
        </GuxFormFieldNumber>
    );
}
